const errors = {
  submit_user: []
}
export default {
  list: [],
  permissions: [],
  initialErrors: { ...errors },
  errors: { ...errors }
}



// WEBPACK FOOTER //
// ./src/features/user/store/state.js